import { configureStore } from "@reduxjs/toolkit";

import rootReducer from "@reducers/root";

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});
